import React from 'react'
import { Modal } from './layout/Modal'
import { useNavigate } from 'react-router-dom'

export const WelcomeModal = (props: any) => {
  const navigate = useNavigate()
  const { isWelcomeModal, setWelcomeModal, userInfo } = props
  return (
    <Modal isModal={isWelcomeModal}>
      <div className="bg-white md:w-[400px] w-[335px]  p-[20px] border-t rounded-t-[40px]">
        <div className="flex flex-col items-center justify-center h-full gap-[24px]">
          <p className="font-bold text-[40px]">🎁 💸</p>
          <p className="font-bold text-[18px]">캐시 선물이 도착했어요!</p>
          <div className="flex flex-col leading-[22px]">
            <p className=" text-[14px] ">
              패스트컷 AI 회원가입 기념
              <br />
              무료 캐시를 적립 해드렸어요!
            </p>
          </div>
          <div>
            {' '}
            <p className="text-[64px] leading-[56px]">
              🤗
              <br />
            </p>
            <p className="font-bold">
              {' '}
              <span className="text-[#FF8800] text-[18px]">얼마일까요?</span>
            </p>
          </div>
          <div>
            <p>
              <span
                className="font-bold text-href underline"
                onClick={() => {
                  setWelcomeModal((prev: boolean) => !prev)
                  navigate('/my-cash-dashboard')
                }}
              >
                캐시 관리
              </span>{' '}
              메뉴에서 금액 확인하고
              <br />
              컨텐츠 영상 만들기에 사용하세요!
            </p>
          </div>
        </div>
      </div>
      <div className="md:w-[400px] w-[335px] text-[14px]  h-[60px]  flex justify-center items-center">
        <button
          className="text-white w-full h-full bg-main rounded-b-[40px] border-b border-main font-bold"
          onClick={() => {
            if (userInfo?.userInfo && !userInfo?.userInfo?.termsAccepted) {
              setWelcomeModal(false)
              navigate('/terms')
            } else {
              setWelcomeModal(false)
            }
          }}
        >
          확인
        </button>
      </div>
    </Modal>
  )
}
